<template>
  <div class="welcome-login pb24">
    <div class="skip-fix header-component mb15 flex-row plr16">
      <skip-login :skip-text="getSkipLoginText" />
    </div>
    <shimmer-login-carousel v-if="!imgArray?.length" :type="true" />
    <div
      :class="showCarouselImg ? 'backgroundLogin' : 'backgroundLoginSmall'"
      v-if="imgArray?.length"
      id="carouselCont"
    >
      <div :style="{ background: imgArray[prevSlide].bgColor }" class="bgArea">
        <div :class="showCarouselImg ? 'sliderCont' : 'sliderContSmall'">
          <Carousel
            :pauseAutoplayOnHover="true"
            :transition="0"
            :touchDrag="true"
            :mouseDrag="true"
            :wrapAround="true"
            :autoplay="3000"
            v-model="currentSlide"
          >
            <Slide
              class="dt-banner-wrap"
              v-for="item in imgArray"
              :key="item?.id"
            >
              <div
                :class="
                  showCarouselImg ? 'backgroundLogin' : 'backgroundLoginSmall'
                "
              >
                <div
                  v-if="showCarouselImg"
                  :style="{ background: item.bgColor }"
                  class="bgArea"
                >
                  <img :src="item.image1" class="login-carousel-img" />
                </div>
                <div
                  :class="showCarouselImg ? 'sliderText' : 'sliderTextSmall'"
                >
                  <div class="sliderTitle" :style="item.titleStyle">
                    {{ item.title }}
                  </div>
                  <div class="sliderSubtitle" :style="item.subTitleStyle">
                    {{ item.subTitle }}
                  </div>
                </div>
              </div>
            </Slide>
          </Carousel>
        </div>
      </div>
    </div>
    <div class="pagination-wrapper">
      <ol
        class="carousel__pagination mt20"
        v-if="loginProps.hasPagination == 'true'"
      >
        <li
          class="carousel__pagination-item"
          v-for="(item, index) in imgArray"
          :key="item?.id"
        >
          <button
            type="button"
            :class="[
              'carousel__pagination-button',
              { 'carousel__pagination-button--active': index == currentSlide },
            ]"
            @click="setCurrentSlide(index)"
            aria-label="Navigate to slide 1"
            :style="
              index == getCurrentSlide ? activeBulletStyle : inActiveBulletStyle
            "
          ></button>
        </li>
      </ol>
    </div>
  </div>
</template>

<script>
import { keyMapsMutation } from "../helpers/storeKeys";
import {
  clientPlatform,
  staticImgBaseUrl,
  apiEndpoints,
} from "../config/apiEndpoints";
import { Carousel, Slide, Pagination } from "vue3-carousel";
import { LoginStates } from "../helpers/loginStateConstants";
import SkipLogin from "./SkipLogin.vue";
import ShimmerLoginCarousel from "./ShimmerLoginCarousel.vue";

export default {
  name: "LoginCarousel",
  components: { SkipLogin, Carousel, Slide, Pagination, ShimmerLoginCarousel },
  props: [
    "moduleProps",
    "propsData",
    "landingOtp",
    "showCarouselImg",
    "showOnlySkip",
  ],
  data() {
    return {
      modulePropsData: {},
      clientPlatform,
      staticImgBaseUrl,
      currentSlide: 0,
      prevSlide: 0,
      apiEndpoints,
    };
  },
  async mounted() {
    this.modulePropsData =
      typeof this.moduleProps != null &&
      typeof this.moduleProps != "null" &&
      typeof this.moduleProps != "undefined"
        ? JSON.parse(this.moduleProps)
        : {};
  },
  methods: {
    setCurrentSlide(index) {
      this.currentSlide = index;
    },
    closeWelcomeLoginModal(e) {
      e.stopPropagation();
      this.$store.commit(
        keyMapsMutation.UPDATE_SHOW_WELCOME_SCREEN_ON_PAGELOAD,
        false
      );
      if (clientPlatform == "Web") {
        this.$store.commit(
          keyMapsMutation.UPDATE_SHOW_PROFILE_DRAWER_MODAL,
          false
        );
      }
      document.body.classList.remove("body-stop-scroll-mobile");
    },
  },
  computed: {
    getCurrentSlide() {
      setTimeout(() => {
        this.prevSlide = this.currentSlide;
      }, 1000);
      return this.currentSlide;
    },
    showWelcomeLoginModal() {
      return this.$store.state.Auth.showWelcomeScreenOnPageLoad;
    },
    isWelcomeLogin() {
      return clientPlatform == "Web"
        ? this.$store.state.Auth.currentLoginState ===
            LoginStates.welcomeLogin &&
            this.$store.state.Auth.showProfileDrawerModal
        : this.$store.state.Auth.currentLoginState ===
            LoginStates.welcomeLogin ||
            this.$store.state.Auth.currentLoginState ===
              LoginStates.otpVerification;
    },
    loginProps() {
      return typeof this.moduleProps != null &&
        typeof this.moduleProps != "null" &&
        typeof this.moduleProps != "undefined"
        ? JSON.parse(this.moduleProps)
        : this.$store.state.Auth.loginProps;
    },
    imgArray() {
      return this.$store.state.User.staticWidgetData?.logincarousel?.map(
        ({ image1, id, props, title, subTitle }) => ({
          image1,
          id,
          bgColor: props.bgColor,
          title,
          subTitle,
          titleStyle: { color: props.title1Color },
          subTitleStyle: { color: props.title2Color },
        })
      );
    },
    currentOrderType() {
      return this.$store.state.User.currentOrderType;
    },
    getSkipLoginText() {
      return "Skip";
    },
    activeBulletStyle() {
      return {
        height: this.loginProps.paginationHeight,
        width: this.loginProps.activePaginationWidth,
        backgroundColor: this.loginProps.activePaginationColor,
      };
    },
    inActiveBulletStyle() {
      return {
        height: this.loginProps.paginationHeight,
        width: this.loginProps.paginationHeight,
        backgroundColor: this.loginProps.inActivePaginationColor,
      };
    },
  },
};
</script>
<style scoped>
.carousel__slide {
  opacity: 0;
  transition: opacity 1s ease-in-out;
}
.carousel__slide--active {
  opacity: 1;
}
</style>
